import tingle from 'tingle.js';

export default function () {
  const modals = document.querySelectorAll('.js-confirm-modal');

  if (!modals) {
    return;
  }

  const confirmModal = new tingle.modal({
    closeMethods: [],
    cssClass: [],
    footer: true,
    stickyFooter: true
  });

  confirmModal.setContent('Weet je zeker dat je deze scorekaart wilt verwijderen?');

  confirmModal.addFooterBtn('Ja, verwijderen', 'btn tingle-btn--margin-left tingle-btn--pull-right', function () {
    confirmModal.close();
  });

  confirmModal.addFooterBtn('Terug', 'btn tingle-btn--margin-left tingle-btn--cancel tingle-btn--pull-right', function () {
    confirmModal.close();
  });

  [].forEach.call(modals, (function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      confirmModal.open();
    });
  }));
};
